import calendarLocalization from '../calendar/localization.js'
import commandMenuLocalization from '../command-menu/localization.js'
import datePickerLocalization from '../date-picker/localization.js'
import messageLocalization from '../message/localization.js'
import modalLocalization from '../modal/localization.js'
import navToggleLocalization from '../nav-toggle/localization.js'
import notificationLocalization from '../notification/localization.js'
import tagLocalization from '../tag/localization.js'
import textareaLocalization from '../textarea/localization.js'

const en = {
  '$lang': 'en-US',
  '$name': 'English',
  '$dir': 'ltr' as 'ltr' | 'rtl',
  'nord-command-menu': commandMenuLocalization,
  'nord-calendar': calendarLocalization,
  'nord-date-picker': datePickerLocalization,
  'nord-modal': modalLocalization,
  'nord-nav-toggle': navToggleLocalization,
  'nord-textarea': textareaLocalization,
  'nord-notification': notificationLocalization,
  'nord-message': messageLocalization,
  'nord-tag': tagLocalization,
}

export default en
